<template>
  <router-view />
</template>
<style>
body {
  background-color: black;
  color: white;
}
</style>
